import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import saveOcsDisplaySetting from '../services/saveOcsDisplaySetting';
import { type FontSize } from '../schema/FontSize';
import type { DisplayOptions } from '../schema/DisplayOptions';

const MINI_DISPLAY_SETTING = 'MiniDisplay';

const defaultDisplaySetting: DisplayOptions = {
    fontSize: 1,
};

export function getDisplaySettings(): DisplayOptions {
    const primeSettings = getUserConfiguration()?.PrimeSettings;
    const miniDisplaySetting = primeSettings?.Items?.find(item => item.Id === MINI_DISPLAY_SETTING);
    const miniDisplaySettingValue = miniDisplaySetting?.Value?.[0]?.value;
    const displaySettings = JSON.parse(miniDisplaySettingValue) ?? defaultDisplaySetting;
    if (miniDisplaySetting && !miniDisplaySettingValue) {
        saveOcsDisplaySetting(displaySettings);
    }
    return displaySettings;
}
